//@import dependencies
import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'
import {useSelector} from 'react-redux'
import { ButtonGroup, ToggleButton } from 'react-bootstrap'
//@end

//@import components
import SchedulingModule from 'app_components/modules/campus/academic/scheduling'
import NewsModule from 'app_components/modules/campus/news'
import ActivitySummaryModule from 'app_components/modules/campus/academic/activitySummary'
import NotesAchievedModule from 'app_components/modules/campus/academic/notesAchieved'
import ActivityDetailsModule from 'app_components/modules/campus/academic/activityDetails'
import RelatedCoursesModule from 'app_components/modules/campus/academic/relatedCourses'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import JoyRideTooltipCommon from 'app_components/commons/joy-ride/joyRideTooltipCommonLayout'
//@end

// @import hooks
// @end

// @INFO Import types
import {IFetchScheduling} from 'app_types/campus/academic/schedulingTypes'
// @end

// @INFO Import services
import HelpStepsService from 'app_services/components/helpSteps/helpStepsService';
// @end

// @INFO Import Styles
import './../studentdashboardModule.scss'
import ModalLearningPath from 'app_components/modules/ModalLearningPath/ModalLearningPath'

// @ADD Component types
interface IStudentdashboardModuleLayoutProps {
  learningWay: IFetchScheduling | null | 'loading'
}

const StudentdashboardModuleLayout: React.FC<IStudentdashboardModuleLayoutProps> = (props) => {

  const helpStepsService = new HelpStepsService()

  const user = useSelector((state: any) => state.auth?.user?.data ? state.auth.user.data : null)

  const { t } = useTranslation()

  const [menuSelected, setMenuSelected] = useState('1');
  const [openPath, updateOpenPath] = useState<boolean>(false)

  const menus = [
    { name: t('modules.student_dashboard.sections.learning_way'), value: '1' }
  ];

  return(
    <div className='student_dashboard-component'>
      {helpStepsService.renderHelpModule('student_dashbord', {
        tooltipComponent: JoyRideTooltipCommon
      })}
      <section className="student-dashboard-section-news" id="student_dashboard_section_news">
        <NewsModule category='student' />
      </section>
      <section className="student-dashboard-main">
        <div className="container-content-dashboard">
          <div id="student_main">
            <div className="student-sections">
              <ButtonComponent
                variant='secondary'
                onClick={() => updateOpenPath(true)}
                disabled={!props.learningWay || props.learningWay === 'loading'}
                loading={props.learningWay === 'loading'}
                id="learning_way"
              >
                Ruta de aprendizaje
              </ButtonComponent>
              {/* <ButtonGroup toggle>
                {menus.map((radio, idx) => (
                  <ToggleButton
                    key={idx}
                    type="radio"
                    variant="secondary"
                    name="radio"
                    value={radio.value}
                    checked={menuSelected === radio.value}
                    onChange={(e) => setMenuSelected(e.currentTarget.value)}
                  >
                    {radio.name}
                  </ToggleButton>
                ))}
              </ButtonGroup> */}
            </div>

            {/* {menuSelected === '1' && ( */}
              <div className="container-activity-notes">
                <div className="container-resume-qualifications" id="student_dashboard_activity">
                  <div id="student_dashboard_activity_summary">
                    <ActivitySummaryModule />
                  </div>
                </div>
                <div className="container-resume-qualifications" id="student_dashboard_activity">
                  <div id="student_dashboard_notes_achieved">
                    <NotesAchievedModule />
                  </div>
                </div>
                <div id="student_dashboard_details">
                  <ActivityDetailsModule />
                  <SchedulingModule role='student'/>
                </div>
              </div>
            {/* )} */}
          </div>
          <div id="student_dashboard_related_courses">
            <RelatedCoursesModule
              content="list"
              title={(
                <>
                  <div className="title">
                    {t('modules.related_courses.title')}
                  </div>
                  <div className="description">
                    {t('modules.related_courses.description')}
                  </div>
                </>
              )}
              hidePrice
            />
          </div>
        </div>
      </section>
      <section></section>
      <ModalLearningPath
        open={openPath}
        onClose={() => updateOpenPath(false)}
        learningWay={props.learningWay}
      />
    </div>
  )
}

export default StudentdashboardModuleLayout
